import React from 'react'
import { ListRow } from './ListRow'
import { useContext } from '../Context'
import { useReportActions } from '../useReportActions'
import { Table } from '@ztechapps/webui.data-tools'
import { Box, EmptyContent } from '@ztechapps/webui.util'
import isEmpty from 'lodash/isEmpty'

export default function FavoriteList() {
  const { loading, favoriteList, removeFavorite, reportTemplateCategories } = useContext()
  const onSelect = useReportActions({ reportTemplateCategories })

  return (
    <Box>
      <Box.Header>
        <b>Favorite Reports</b>
      </Box.Header>
      <Box.Body>
        <Table
          dataArray={favoriteList}
          isEmpty={isEmpty(favoriteList)}
          loading={loading}
          emptyContent={
            <EmptyContent
              icon="file-code"
              message="You don't have any favorite reports to display."
              subMessage="You can add one by clicking the heart 💛 icon from 'All Reports' list, or remove it from this list by clicking the heart icon here after it was added."
            />
          }
          row={({ ...rest }) => <ListRow {...rest} {...{ removeFavorite, onSelect }} />}
          height={'60vh'}
        />
      </Box.Body>
    </Box>
  )
}
